import React from "react";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import INFO from "../../data/user";
import "../common/styles/socials.css";

const Socials = () => {
  return (
    <div className="socials">
      <div className="social">
        <a href={INFO.socials.github} target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faGithub} className="social-icon" />
          <span className="social-text">Follow on GitHub</span>
        </a>
      </div>

      <div className="social">
        <a href={INFO.socials.linkedin} target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
          <span className="social-text">Follow on LinkedIn</span>
        </a>
      </div>

      <div className="social">
        <a href={INFO.socials.instagram} target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          <span className="social-text">Follow on Instagram</span>
        </a>
      </div>

      <div className="email">
        <div className="email-wrapper">
          <a
            href={`mailto:${INFO.main.email}`}
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faEnvelope} className="social-icon" />

            <span className="social-text">{INFO.main.email}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Socials;
